import _ from "lodash";
import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { IS_MOBILE } from "../../constants/Constants";
import { LIVE_HOST, settings } from "../../constants/host";
import PassImage from "../../assets/images/login/pass_icon.png";
import EmailImage from "../../assets/images/login/email_icon.png";
import CloudImage from "../../assets/images/login/cloud_icon.png";
import { adminLogin, clearToken, setAuthTokenState } from "../../actions/authActions";
import ClinicLogoImage from "../../assets/images/clinic_logo@2x.png";
import { Routes } from "../../constants/Routes";
import BackGroundImage from "../../assets/images/register-device/register_device_bg.jpg";
import FormBackGroundImage from "../../assets/images/clinic_bg.png";
import { obtainImagePath } from "../../utils/ImageUtils";
import ReCaptcha from "../ui/ReCaptcha";
import { recaptchaSiteKey } from "../../constants/Constants";
import Countdown from "../ui/Countdown";
import cn from "classnames";

const RegisterDeviceLogin = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const recaptchaRef = useRef(null);
  const [recaptchaToken, setRecaptchaToken] = useState("");
  const [canResend, setCanResend] = useState(false);
  const [formValues, setFormValues] = useState({});

  const {
    showAuthCaptcha,
    authCaptchaError,
    isMfaRequired,
    isRedirectedFromMemberLogin,
    token,
  } = useSelector((state) => state.auth);
  const { clinic } = useSelector((state) => state.session);
  const mfaToken = _.get(token, "access_token");
  const expiresIn = _.get(token, "expires_in");

  const handleSubmit = (event) => {
    event.preventDefault();

    localStorage.removeItem("userToken");
    if (showAuthCaptcha && !recaptchaToken) return;

    let transfer = {
      username: event.target.email?.value,
      password: event.target.password?.value,
      work_mode: "default",
      grant_type: "password_with_mfa",
    };
    if (recaptchaToken) transfer = { ...transfer, captcha_token: recaptchaToken };

    if (isMfaRequired) {
      transfer = {
        ...transfer,
        code: event.target.code.value,
        grant_type: "mfa_verify",
        mfa_token: mfaToken,
      };
    }

    const host = event.target.host.value || "";
    const lastHostLetter = _.last(host.split(""));
    const newHost = lastHostLetter === "/" ? host : host + "/";

    settings.host = newHost;

    localStorage.setItem("host", newHost);

    if (!isMfaRequired) {
      dispatch(clearToken());
    }

    if (IS_MOBILE) {
      localStorage.setItem("loggedIn", false);
    }

    localStorage.setItem("loggedIn", false);
    setFormValues(transfer);
    dispatch(adminLogin(transfer)).then((response) => {
      if (response && response.data && !isMfaRequired) {
        history.push(Routes.DashboardChooseClinic);
      }
    });
  };

  const handleResend = () => {
    setCanResend(false);
    dispatch(clearToken());

    dispatch(adminLogin(formValues));
  };

  const handleRecaptcha = (token) => {
    if (token) {
      setRecaptchaToken(token);
      dispatch(setAuthTokenState(false));
      recaptchaRef.current.reset();
    }
  };

  const handleCountdownChange = (show) => {
    setCanResend(show);
  };

  return (
    <div
      className="register-device-login"
      style={{
        backgroundImage: `url(${obtainImagePath(BackGroundImage)})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "bottom",
      }}
    >
      <div className="logo">
        <img src={ClinicLogoImage} alt="" />
      </div>
      <form onSubmit={handleSubmit} style={{ backgroundImage: `url(${FormBackGroundImage})` }}>
        <div className="title">sign in to your account</div>
        <div className="sub-title">Please use only an admin account to start using the app</div>
        <div className="inputs">
          <div className="input-group input-group-lg">
            <span className="input-group-addon">
              <img alt="" src={EmailImage} />
            </span>
            <input
              className="form-control"
              type="email"
              name="email"
              placeholder="Email"
              disabled={isRedirectedFromMemberLogin}
              defaultValue={isRedirectedFromMemberLogin ? clinic?.email : ""}
            />
          </div>
          {!isRedirectedFromMemberLogin && (
            <div className="input-group input-group-lg">
              <span className="input-group-addon" style={{ borderRadius: "0px" }}>
                <img alt="" src={PassImage} />
              </span>
              <input
                className="form-control"
                style={{ borderRadius: "0px" }}
                type="password"
                name="password"
                placeholder="Password"
              />
            </div>
          )}
          <div className="input-group input-group-lg">
            <span className={cn("input-group-addon", { "input-border-style": isMfaRequired })}>
              <img alt="" src={CloudImage} style={{ paddingRight: "1px" }} />
            </span>
            <input
              className={cn("form-control", { "input-border-style": isMfaRequired })}
              name="host"
              disabled={isRedirectedFromMemberLogin}
              placeholder="Host"
              defaultValue={localStorage.getItem("host") || LIVE_HOST}
            />
          </div>
          {isMfaRequired && (
            <div className="input-group input-group-lg">
              <span className="input-group-addon">
                <img alt="" src={PassImage} />
              </span>
              <div className="mfa-input-field">
                <input
                  className="form-control mfa-input"
                  type="text"
                  name="code"
                  placeholder="Verify code"
                  style={{ border: "unset" }}
                />
                <div className="remaining-time-field">
                  <span className="time">
                    <Countdown
                      key={expiresIn}
                      totalSeconds={expiresIn}
                      onCountdownChange={handleCountdownChange}
                    />
                  </span>
                  {canResend && (
                    <button
                      type="button"
                      className="btn btn-sm btn-block btn-success"
                      onClick={handleResend}
                    >
                      Resend
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
        {showAuthCaptcha ? (
          <div className="w-100 d-flex flex-column align-items-center mt-2">
            <span className="captcha-error">{authCaptchaError}</span>
            <ReCaptcha ref={recaptchaRef} sitekey={recaptchaSiteKey} onChange={handleRecaptcha} />
          </div>
        ) : (
          <div className="sign-in-button" style={{ marginTop: "30px" }}>
            <button type="submit" className="btn btn-lg btn-block btn-success">
              Connect to my account
            </button>
          </div>
        )}
      </form>
    </div>
  );
};

export default RegisterDeviceLogin;
